import React from 'react'

function EyeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}

function EyeSlashIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M3 3l18 18" />
      <path d="M10.58 10.58A3 3 0 0 0 12 15a3 3 0 0 0 2.42-4.42" />
      <path d="M9.88 5.09A10.94 10.94 0 0 1 12 5c6.5 0 10 7 10 7a18.6 18.6 0 0 1-3.17 4.34" />
      <path d="M6.11 6.11A18.6 18.6 0 0 0 2 12s3.5 7 10 7a10.94 10.94 0 0 0 5.91-1.7" />
    </svg>
  )
}

const SsoCodeInput = ({
  handleChange,
  value,
  label,
  ...rest
}: {
  handleChange: (value: string) => void
  label: string
  value: string
} & React.InputHTMLAttributes<HTMLInputElement>) => {
  const [showPassword, setShowPassword] = React.useState(false)

  if (rest.hidden) return null

  const Icon = showPassword ? EyeIcon : EyeSlashIcon

  return (
    <div className="relative z-0 w-full mb-2 group">
      <label
        htmlFor="ssoCode"
        className="block mb-2 text-xs uppercase text-white/70"
      >
        <strong>{label}</strong>
      </label>
      <div className="relative">
        <input
          name="ssoCode"
          id="ssoCode"
          type={showPassword ? 'text' : 'password'}
          // Habilita o autofill de código do Safari/iOS. O SMS termina na linha
          // domain-bound `@goodfellas.app #123456`, e o Safari só oferece o
          // código num campo que se declara como one-time-code. `inputMode`
          // numérico abre o teclado de dígitos no mobile.
          autoComplete="one-time-code"
          inputMode="numeric"
          value={value}
          onChange={(event) => handleChange(event.target.value)}
          className="w-full text-gray-900 border border-gray-300 rounded-full bg-gray-50 text-base focus:ring-red-500 focus:border-red-500 pl-4 pr-10 h-14 appearance-none"
          {...rest}
        />
        <button
          type="button"
          aria-label={showPassword ? 'Esconder código' : 'Mostrar código'}
          className="absolute cursor-pointer right-6 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-gray-900"
          onClick={() => setShowPassword((prev) => !prev)}
        >
          <Icon className="h-5 w-5" />
        </button>
      </div>
    </div>
  )
}

export default SsoCodeInput
